import type { ModuleType } from '../types/index.js';

export interface ThemeDefinition {
  id: string;
  label: string;
  description: string;
  supportedModules: ModuleType[];
  preview?: string;
}

export const THEMES: ThemeDefinition[] = [
  {
    id: 'restaurant-1',
    label: 'Bistro',
    description: 'Classic restaurant layout with hero, menu, hours, and gallery.',
    supportedModules: ['business-info', 'menu', 'hours', 'gallery', 'announcement'],
  },
  {
    id: 'restaurant-2',
    label: 'Modern Eatery',
    description: 'Modern minimal design with photo-forward menu presentation.',
    supportedModules: ['business-info', 'menu', 'hours', 'gallery', 'announcement'],
  },
];

export function getTheme(id: string): ThemeDefinition | undefined {
  return THEMES.find((t) => t.id === id);
}
